import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

function checkLang() {
  let langs = navigator.languages || navigator.userLanguage || []
  if(typeof langs === 'string') langs = langs.split(',')
  const navLangs = ['en', 'de', 'es', 'fr', 'it', 'nl', 'pt', 'sv', 'zh', 'ja', 'ko']
  const langsCN = ['cn', 'sg', 'us', 'hans']
  const langsTW = ['tw', 'hk', 'mo', 'hant']
  let navlang = 'en'
  let langSeparate = []

  for (let i = 0, len = langs.length; i < len; i++) {
    langSeparate = langs[i].split(';')[0].split(/[-_]/)
    const lang = langSeparate[0].toLowerCase()
    if (navLangs.indexOf(lang) > -1) {
      if (lang === 'zh' && langSeparate[1] !== undefined) {
        if (langsCN.indexOf(langSeparate[1].toLowerCase()) > -1) {
          navlang = 'cn'
          break
        } else if (langsTW.indexOf(langSeparate[1].toLowerCase()) > -1) {
          navlang = 'tw'
          break
        }
      } else if (lang === 'zh') {
        continue
      } else {
        navlang = lang
        break
      }
    }
  }
  return navlang
}

export default new VueI18n({ 
  locale: checkLang() || process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
